module.exports = __webpack_public_path__ + "img/hope.8f028bb6.png";